import { Link } from 'react-router-dom';
import { I18n } from '@/i18n/I18n';
import { useProcedureInstanceStore } from '@/frontend/store/ProcedureInstanceStore';
import { PROCEDURETYPE } from '@/backend/models/procedureInstances/procedureInstanceBase';
import { ProcedureInstance } from '@/backend/models/procedureInstances/procedureInstance';
import { NavigationTabButton } from './NavigationTabButton';
import { RunPreviewButton } from './RunPreviewButton';

export function ProcedureTabsNavigation() {
  const procedure = useProcedureInstanceStore((state) => state.procedureInstance) as ProcedureInstance;

  if (!procedure) {
    return null;
  }

  return (
    <div className='sticky-top d-print-none d-flex pe-none flex-column gap-2'>
      <ul className="nav nav-tabs pt-1 pe-auto bg-body" style={{ top: '56px' }}>
        <div className='w-100 d-flex justify-content-between'>
          <div className='d-flex gap-1'>
            { !procedure.signature && procedure.isTemplate() &&
              <NavigationTabButton tabName='scaffold' routeName='scaffold' procedureId={procedure.id} />
            }
            { (!procedure.signature && !procedure.isTemplate()) &&
              <NavigationTabButton tabName='editMode' routeName='edit' procedureId={procedure.id} />
            }
            <NavigationTabButton tabName={procedure.isTemplate() ? 'previewRunMode' : 'runMode'} routeName='run' procedureId={procedure.id} />
            { procedure.procedureType === PROCEDURETYPE.RUN &&
              <li className="nav-item">
                <Link className="nav-link" to={`/runs/${procedure.id}/report`} aria-label={I18n.get('testReportTab')} title={I18n.get('testReportTab')}>
                  <p className="my-auto text-nowrap">{I18n.get('testReportTab')}</p>
                </Link>
              </li>
            }
          </div>
          <div className='pe-3 pt-1'>
            <RunPreviewButton />
          </div>
          {/* <div className='d-flex gap-2'>
            <ContextMenu>
            <Link className='btn border-0 pb-2 d-flex align-items-center gap-2' to={`/procedures/wizard/${procedure?.id}/setup`}>
              {I18n.get('wizardView')}
            </Link>
            </ContextMenu>
          </div> */}
        </div>
      </ul>
      <div className='d-flex align-items-center pe-none flex-column' >
        
        {/* <RecordingBanner /> */}
      </div>
    </div>
  );
}
